module.exports = __webpack_public_path__ + "static/media/explosion-white.57f64640.png";